import { render, staticRenderFns } from "./UserPresenceModal.vue?vue&type=template&id=6328f322"
import script from "./UserPresenceModal.vue?vue&type=script&lang=ts"
export * from "./UserPresenceModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports